export enum ActionType {
    POWER_BI__RELOAD = 'POWER_BI__RELOAD',
    POWER_BI__RELOAD_RESULT = 'POWER_BI__RELOAD_RESULT',
}
